import { Component, OnInit } from '@angular/core';
import { ExamService } from 'src/app/services/Exam/exam.service';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { GlobalHelper } from 'src/app/services/Common/global.service';

@Component({
  selector: 'app-student-elective',
  templateUrl: './student-elective.component.html',
  styleUrls: ['./student-elective.component.css']
})
export class StudentElectiveComponent implements OnInit {

  constructor(private examService:ExamService,private lookupService: LookupService, private globalHelper: GlobalHelper,     private spinnerService: Ng4LoadingSpinnerService) { }
  
  ClassDetails = {
    StudentID: 0,
    ClassID: 0,
    SectionID: 0,
    SessionID: 0,
    SubjectID: 0,
    ClassName: '',
    ClassSectionID: ""
}
propertyName = 0;
reverse = true;


sortBy(propertyName) {
     this.reverse = (propertyName !== null &&  this.propertyName === propertyName)
        ? ! this.reverse : false;
     this.propertyName = propertyName;

};
AcademicSessionList:any;;
 GetAcademicSession  () {
    this.lookupService.GetLookupsList('AcademicSession', '').subscribe( (data)=> {
         this.AcademicSessionList = data.LookupItems;
    });
};

StudentSubjectList:any;
GetStudentElective  () {
    this.spinnerService.show();
    var ItemBO = {
        ItemId:  this.ClassDetails.ClassID,              
    }
    this.lookupService.GetLookupsList('ElectiveSubject', JSON.stringify(ItemBO)).subscribe( (data)=> {
         this.StudentSubjectList = data.LookupItems;
       this.spinnerService.hide();
    });
};



 GetStudentElectiveByClassID  () {
    this.spinnerService.show();
    
    this.examService.GetStudentElectiveByClassID( this.ClassDetails.ClassID,  this.ClassDetails.SectionID, this.ClassDetails.SubjectID).subscribe( (data)=> {
         this.StudentElectiveList = data.StudentElectiveList;
         
       this.spinnerService.hide();
    });
}


StudentElectiveList:any;
 SaveStudentElective  () {
     
    this.examService.SaveStudentElective(JSON.stringify( this.ClassDetails), JSON.stringify( this.StudentElectiveList)).subscribe( (response)=> {
        

        this.globalHelper.CheckActionStatus(response);
         

    });

}


ClassSectionList:any;
 GetClassSection  () {
    this.lookupService.GetLookupsList('CTClassSection', '').subscribe( (data)=> {
         this.ClassSectionList = data.LookupItems;

    });

};

 SetID  () {
     this.ClassDetails.ClassID = 0;
     this.ClassDetails.SectionID = 0;
     
    if ( this.ClassDetails.ClassSectionID != "") {
        var strClassSectionID =  this.ClassDetails.ClassSectionID.toString().split('-');
         this.ClassDetails.ClassID = parseInt(strClassSectionID[0]);
         this.ClassDetails.SectionID = parseInt(strClassSectionID[1]);
         
         this.GetStudentElective();
        
    }

}

  ngOnInit() {
    this.GetClassSection();
  }

}
